cv.CustomFieldsRowEmptyView = Marionette.LayoutView.extend({
  tagName : 'div',
  className: 'form-group',
  template : cv.Templates['global/custom_fields_form/custom_fields_row_empty'],

  behaviors : [{
    behaviorClass : cv.FormBehavior,
    suppress_notifications: true
  }],

  events : {
  },

  validation: {

  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('CustomFieldRowEmptyView initialized');
  },

  onShow: function(){
    vent.trigger('custom_field:unlink_field', this);
  },

  onDestroy: function(){
  }
});
